export enum WhatsAppCallingCallbackPermission {
    NOT_SET = 'NOT_SET',
    ENABLED = 'ENABLED',
    DISABLE = 'DISABLED',
  }
  